import { normalizePhoneNumber, isValidPhoneNumber, phoneNumberValidator } from '../../../../core/validators/phone-number';
import {Component, computed, inject, Inject, OnInit, signal} from '@angular/core';
import { fuseAnimations } from '../../../../core/animations';
import { ActivatedRoute } from '@angular/router';
import { OrganizationsService } from '../../../../core/services/organizations.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FrontUserService } from '../../../../core/services/frontUsers.service';
import { checkEmailOnServer, emailValidator } from '../../../../core/validators/validators';
import { FrontUserFormDialogComponent } from './setting-form/setting-form.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DocumentsService } from '../../../../core/services/documents.service';
import { LoaderService } from '../../../../core/services/loader.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as _ from 'lodash';
import { RewardsModalComponent } from '../addRewards/rewards';
import moment from 'moment';
import { FuseDeleteDialogComponent } from '../../../../core/components/delete-dialog/delete-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { FuseConfigService } from '../../../../core/services/config.service';
import { Observable, Subscription } from 'rxjs';
import { FuseNavigationService } from '../../../../core/components/navigation/navigation.service';
import { GenderFuncService } from '../../../../core/services/genderFunc.service';
import { AddConnection } from './addConnectionModal/addConnection';
import { CheckRoleModalComponent } from './checkModal/check-modal.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EventService } from '../../../../core/services/event.service';
import { Location } from '@angular/common';
import { distinctUntilChanged, finalize, map, startWith } from 'rxjs/operators';
import {ForumTalkService} from '../../../../core/services/forumTalk.service';
import {AdditionalFrontUserInfoService} from '../../../../core/services/additionalFrontUserInfo.service';
import {Task, TaskGroupService} from '../../../../core/services/taskGroup.service';
import {FrontUserTaskService} from '../../../../core/services/frontUserTask.service';
import {ParishOrganizationService} from '../../../../core/services/parishOrganization.service';
import {RejectTaskDialogComponent, RejectTaskDialogResult} from './reject-task-dialog/reject-task-dialog.component';
import {CertificateTemplateService} from '../../../../core/services/certificateTemplate.service';
import {AddTaskModalComponent, AddTaskModalData, UserTaskAssignment} from './add-task-modal/add-task-modal.component';

moment.locale('de');

@Component({
    selector: 'frontuser-detail-page',
    templateUrl: './frontuser-detail.component.html',
    styleUrls: ['./frontuser-detail.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class FrontUserDetailComponent implements OnInit {
  forumTalkService = inject(ForumTalkService);
  taskService = inject(TaskGroupService);
  frontUserTaskService  = inject(FrontUserTaskService);
  additionalService = inject(AdditionalFrontUserInfoService);
  private parishOrganizationService = inject(ParishOrganizationService);
  private certificateTemplateService = inject(CertificateTemplateService);

  parishOrganizations: { id: number; name: string }[] = [];
  activities: { id: number; name: string }[] = [];
  parishOrgs: { parishOrganizationId: number | null; activityId: number | null }[] = [
    {parishOrganizationId: null, activityId: null}
  ];
  savingParishOrgs = false;
  loadingParishOrgs = false;
  activeAdditionalFrontUserInfo: { id: number; title: string }[] = [];
  additionalFrontUserInfo: { id: number; info: boolean }[] = [];

  // forumTalkEnabled = computed(() => this.forumTalkService.forumChatEnabled());

  forumTalkEnabled = signal(false);

  taskEnabled = this.taskService.taskEnabled;
  certificateEnabled = this.certificateTemplateService.certificateEnabled;

  certificatesMap = new Map<string, any>();

  user: any;
  public nextTrainingYears = Array.from({length: 31}, (_, index) => new Date().getFullYear() + index);
  public formGroup: FormGroup = new FormGroup({
    frontRoleId: new FormControl('', Validators.required),
    firstName: new FormControl({value: '', disabled: true}, Validators.required),
    lastName: new FormControl({value: '', disabled: true}, Validators.required),
    nickName: new FormControl({value: '', disabled: true}),
    email: new FormControl({value: '', disabled: true}, [emailValidator, checkEmailOnServer]),
    countryId: new FormControl({value: '', disabled: true}, Validators.required),
    cityId: new FormControl({value: '', disabled: true}, Validators.required),
    organizationId: new FormControl({value: '', disabled: true}, Validators.required),
    tagId: new FormControl({value: '', disabled: true}),
    lang: new FormControl({value: '', disabled: true}, Validators.required),
    gender: new FormControl({value: '', disabled: true}, Validators.required),
    street: new FormControl({value: '', disabled: true}),
    number: new FormControl({value: '', disabled: true}),
    postcode: new FormControl({value: '', disabled: true}),
    cityLocation: new FormControl({value: '', disabled: true}),
    phone: new FormControl({value: '', disabled: true}, phoneNumberValidator),
    mobile: new FormControl({value: '', disabled: true}, phoneNumberValidator),
    dateOfBirth: new FormControl({value: '', disabled: true}),
    abschlussjahr: new FormControl({value: '', disabled: true}),
    dateOfBaptism: new FormControl({value: '', disabled: true}),
    dateOfConfirmation: new FormControl({value: '', disabled: true}),
    introdactionDate: new FormControl({value: '', disabled: true}),
    targetGroupId: new FormControl({value: '', disabled: true}),
    status: new FormControl({value: '', disabled: true}),
    confessionId: new FormControl({value: '', disabled: true}),
    notes: new FormControl({value: '', disabled: true}),
    showFoto: new FormControl({value: '', disabled: true}),
    showChildrenName: new FormControl({value: '', disabled: true}),
    showNick: new FormControl({value: '', disabled: true}),
    isMember: new FormControl({value: '', disabled: true}),
    loginType: new FormControl({value: '', disabled: true}),
    platformId: new FormControl({value: '', disabled: true})
  });
  public editing = false;
  public readArray = [];
  dialogRef: any;
  dataTGCurrent: any = {};
  dataTGSelected: any = {};
  updateDate = moment().valueOf();
  updateDateSelected = moment().valueOf();
  allTG: any = [];
  allTgIds = '';
  index = 0;
  private subscriptions = new Subscription();
  public img;
  public uploadedImg = null;
  fileAccess = [];
  competencies = [];
  public readonlyData = {
    frontRole: {
      label: 'user.role',
      data: ''
    },
    firstName: {
      label: 'user.firstName',
      data: ''
    },
    lastName: {
      label: 'user.lastName',
      data: ''
    },
    nickName: {
      label: 'user.nickName',
      data: ''
    },
    email: {
      label: 'user.email',
      data: ''
    },
    country: {
      label: 'user.country',
      data: ''
    },
    organization: {
      label: 'user.organization',
      data: ''
    },
    tag: {
      label: 'main.tag',
      data: ''
    },
    lang: {
      label: 'user.lang',
      data: ''
    },
    gender: {
      label: 'user.gender',
      data: ''
    },
    street: {
      label: 'user.street',
      data: ''
    },
    number: {
      label: 'user.number',
      data: ''
    },
    postcode: {
      label: 'user.postcode',
      data: ''
    },
    city: {
      label: 'user.city',
      data: ''
    },
    phone: {
      label: 'user.phone',
      data: ''
    },
    mobile: {
      label: 'user.mobile',
      data: ''
    },
    dateOfBirth: {
      label: 'user.dateOf_birth',
      data: ''
    },
    abschlussjahr: {
      label: 'user.abschlussjahr',
      data: ''
    },
    dateOfBaptism: {
      label: 'user.dateOfBaptism',
      data: ''
    },
    introdactionDate: {
      label: 'user.introdactionDate',
      data: ''
    },
    dateOfConfirmation: {
      label: 'user.dateOfConfirmation',
      data: ''
    },
    targetGroup: {
      label: 'user.targetGroup',
      data: ''
    },
    detailOfTargetGroup: {
      label: 'user.detailTargetGroup',
      data: ''
    },
    statusLevel: {
      label: 'user.status-level',
      data: ''
    },
    confession: {
      label: 'user.confession',
      data: ''
    },
    notes: {
      label: 'user.notes',
      data: ''
    },
    showFoto: {
      label: 'user.showFoto',
      data: ''
    },
    showChildrenName: {
      label: 'user.showChildrenName',
      data: ''
    },
    isMember: {
      label: 'user.isMember',
      data: ''
    }
  };
  public countries = [];
  public cities = [];
  public organizations = [];
  public tags = [];
  public parentPage = false;
  public studentPage = false;
  public logo;
  public files;
  public documentData;
  public language;
  public events;
  public eventsScore;
  public newEventsScore = 0;
  public oldEventsScore = 0;
  public rewards;
  validateButton = false;
  selected;
  current;
  isParent = false;
  clan;
  showBooked = true;
  showEnded = true;
  colorShema = {
    basic: 'rgba(0, 122, 127, 0.99)',
    purple: 'rgba(59, 0, 127, 0.66)',
    gray: 'rgba(88, 88, 88, 0.71)',
    red: 'rgba(127, 0, 25, 0.61)',
    cyan: 'rgba(0, 35, 127, 0.69)',
    blue: 'rgba(34, 74, 127, 0.69)',
    green: 'rgba(0, 127, 49, 0.73)',
    yellow: 'rgba(127, 110, 0, 0.71)',
    orange: 'rgba(127, 66, 9, 0.71)',
  };
  id;
  dynamicOrg;
  eCall = false;
  whatsapp = false;
  timelines;
  credits;
  TGForRewards: any = [];
  connectedAdult: any = [];
  connectedYoung: any = [];
  connectedRelatives: any = [];
  adultExist: any = false;
  youngExist: any = false;
  prefix;
  public roles = [];
  public levelStatuses = [];
  public targetGroups = [];
  public confessions = [];
  public languages = [ {label: 'English' , value: 'en'} , {label: 'Deutsch' , value: 'de'}, {label: 'Français' , value: 'fr'} ];
  public genders = [ {label: 'Mann' , value: 'male'} , {label: 'Frau' , value: 'female'}, {label: 'Divers', value: 'diverse'} ];
  organizationForFollowing = [];
  followingOranization = [];
  addingOrganization = false;
  selectedOrg = new FormControl<any>('');
  filteredOptions!: Observable<any[]>;
  private selectedOrgSubscription!: Subscription;
  selectedOrgObj;

  platformId;
  isOrganizer = false;
  isSuperAdmin = false;
  noOrganization = false;
  guestOrganization;

  platforms = [];
  backInProcess = false;
  countdown  = 5;

  constructor(private route: ActivatedRoute, private spinner: NgxSpinnerService,
              private userService: FrontUserService, public dialog: MatDialog,
              private router: Router, private organizationService: OrganizationsService,
              private documentService: DocumentsService,
              private loaderService: LoaderService, private navigationService: FuseNavigationService,
              public translate: TranslateService, public toastr: ToastrService, private fuseConfig: FuseConfigService,
              public genderService: GenderFuncService, public snackBar: MatSnackBar,
              public eventService: EventService, private location: Location) {
    this.fuseConfig.eCall.subscribe(res => {
      if (res && res !== 'null') {
        this.eCall = true;
      }
    });
    this.fuseConfig.whatsapp.subscribe(res => {
      if (res && res !== 'null') {
        this.whatsapp = true;
      }
    });
    this.fuseConfig.selectedPlatform.subscribe(res => {
      if (res && res.id) {
        this.platformId = res.id;
      }
    });
    this.fuseConfig.role.subscribe(res => {
      this.isOrganizer = res && res === 'organisationAdmin';
      this.isSuperAdmin = res && res === 'superAdmin';
      if (res && res === 'superAdmin') {
        this.forumTalkEnabled.set(true);
        this.taskEnabled.set(true);
      } else {
        this.forumTalkEnabled.set(false);
      }
    });
    this.id = this.route.snapshot.queryParamMap.get('id');
    this.language = translate.currentLang;
    this.getInfoAboutUser();
  }

  checkNoOrganization(event) {
    if (!this.guestOrganization && event) {
      this.organizationService.getGuestOrganization().subscribe({
        next: (result: any) => {
          if (result) {
            this.guestOrganization = result;
          }
        },
        error: (err: any) => {}
      });
    }
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  getCertificateDocumentUrl(name: string) {
    return this.documentService.getFileStream(name);
  }

  goBack() {
    this.location.back();
  }

  getAllUserData() {
    this.userService.getTimeLine(this.id).subscribe((res: any) => {
      this.timelines = res;
    });
    this.userService.getAllTG(this.id).subscribe((res: any) => {
      if (res && res.length) {
        this.allTG = res;
        this.selected = res[0].id;
        this.current = res[0].id;
        const ids = this.allTG.map((el) => el.id);
        this.allTgIds = ids.join(',');
        this.getAllUserTg(this.id);
      }
    });

    this.userService.getUserTG(this.id, '').subscribe((res) => {
      if (res) {
        this.dataTGCurrent = res;
        this.dataTGSelected = res;
      }
    });
    this.getEvents();
    this.userService.getListOfRewards(this.id, '').subscribe((res) => {
      if (res) {
        this.rewards = res;
      }
    });
    this.documentService.getDocuments(this.id, 'frontUser').subscribe((res: any) => {
      if (res.length) {
        for (let item of res) {
          item.url = item.name;
          item.type = item.name.substring(item.name.lastIndexOf('.') + 1, item.name.length);
          item.name = item.name.split('|_|')[1];
        }
      }
      this.files = res;
    });
    this.getClan();
    this.getConnection(this.id);
  }

  getEvents() {
    this.spinner.show();
    this.userService.getEvents(this.id, '').subscribe((res: any) => {
      if (res) {
        this.events = res;
        this.eventsScore = res;
        if (this.eventsScore && this.eventsScore.newEvents) {
          this.newEventsScore = this.eventsScore.newEvents.reduce((sum, current) => {
            let value = 0;
            if (current && current.event && current.event.credits) {
              value = current.event.credits;
            }
            return sum + value;
          }, 0);
        }
        if (this.eventsScore && this.eventsScore.oldEvents) {
          this.oldEventsScore = this.eventsScore.oldEvents.reduce((sum, current) => {
            let value = 0;
            if (current && current.credits) {
              value = current.credits;
            } else {
              if (current && current.event && current.event.credits) {
                value = current.event.credits;
              }
            }

            return sum + value;
          }, 0);
        }
        if (this.eventsScore && this.eventsScore.manual) {
          this.oldEventsScore = this.oldEventsScore + this.eventsScore.manual.reduce((sum, current) => {
            let value = 0;
            if (current && current.credits) {
              value = current.credits;
            }
            return sum + value;
          }, 0);
        }
        this.dynamicOrg = res.dynamicOrg;
      }
      this.spinner.hide();
    });
  }

  backProcess() {
    this.countdown = 5;
    const timer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(timer);
        this.router.navigate(['./pages/frontusers']);
      }
    }, 1000);
  }

  getInfoAboutUser() {
    this.userService.getUserById(this.id).subscribe((data: any) => {
      if (!data) {
        this.spinner.hide();
        this.backInProcess = true;
        this.backProcess();
        return;
      }
      if (data) {
        this.getAllUserData();
      }
      if (data.logo) {
        this.img = data.logo;
        this.logo = data.logo;
      }
      if (data.frontRoleId === 2) {
        this.isParent = true;
      }
      this.prefix = this.isParent ? 'parent' : 'student';
      if (data.dateOfBirth === 'Invalid date') {
        data.dateOfBirth = '';
      }
      if (data.dateOfBirth && data.dateOfBirth !== 'Invalid date') {
        let _db: any = moment(data.dateOfBirth, 'DD.MM.YYYY');
        if (isNaN(_db)) {
          _db = moment(data.dateOfBirth);
        }
        data.dateOfBirth = _db;
      }
      if (data.dateOfBaptism === 'Invalid date') {
        data.dateOfBaptism = '';
      }
      if (data.dateOfBaptism && data.dateOfBirth !== 'Invalid date') {
        let _db: any = moment(data.dateOfBaptism, 'DD.MM.YYYY');
        if (isNaN(_db)) {
          _db = moment(data.dateOfBaptism);
        }
        data.dateOfBaptism = _db;
      }
      this.user = data;
      if (this.user.organizationId === 289) {
        this.formGroup.addControl('nextTrainingYear', new FormControl<number | null>(null));
      } else {
        this.formGroup.removeControl('nextTrainingYear');
      }
      this.additionalFrontUserInfo = (data.frontUserInfo || []).map(item => ({
        id: item.additionalFrontUserInfoId,
        info: item.info === 'true'
      }));
      for (const certificate of (data.certificates || [])) {
        if (certificate.eventId) {
          this.certificatesMap.set('event_' + certificate.eventId, certificate);
        } else if (certificate.taskId) {
          this.certificatesMap.set('task_' + certificate.taskId, certificate);
        } else if (certificate.elearningId) {
          this.certificatesMap.set('elearning_' + certificate.elearningId, certificate);
        } else if (certificate.learningPathsId) {
          this.certificatesMap.set('learningPaths_' + certificate.learningPathsId, certificate);
        }
      }

      this.activeAdditionalFrontUserInfo = [];
      if (+this.user.organizationId === 289) {
        this.loadingParishOrgs = true;
        this.subscriptions.add(this.parishOrganizationService.getByFrontUserId(+this.user.id).pipe(
          finalize(() => this.loadingParishOrgs = false)
        ).subscribe({
          next: response => {
            this.parishOrgs = response.map(item => ({
              parishOrganizationId: item.parishOrganizationId,
              activityId: item.activityId
            }));
            if (!this.parishOrgs.length) {
              this.addParishOrg();
            }
          },
          error: () => {
            this.toastr.error(this.translate.instant('failure'));
          }
        }));
        this.subscriptions.add(this.parishOrganizationService.parishOrganizationsOpen().subscribe({
          next: (response: {
            parishOrganizations?: { id: number; name: string }[];
            functionType?: { id: number; name: string }[];
          }) => {
            this.parishOrganizations = response?.parishOrganizations || [];
            this.activities = response?.functionType || [];
          },
          error: () => {
            this.parishOrganizations = [];
            this.activities = [];
            this.toastr.error(this.translate.instant('failure'));
          }
        }));
        this.subscriptions.add(this.additionalService.getActiveAdditionalFrontUserInfo().subscribe({
          next: response => {
            this.activeAdditionalFrontUserInfo = response;
            this.additionalFrontUserInfo = response.map(item => ({
              id: item.id,
              info: this.additionalFrontUserInfo.find(value => +value.id === +item.id)?.info ?? false
            }));
          },
          error: () => {
            this.activeAdditionalFrontUserInfo = [];
          }
        }));
      }
      if (this.user.showFollowing) {
        this.getOrgForFollowing();
      }
      if (this.user?.showPlatforms?.length) {
        this.platforms = [];
        for (let i = 0; i < this.user?.showPlatforms.length; i++) {
          let index = this.platforms.findIndex(p => +p.id === +this.user?.showPlatforms[i].platformId);
          if (index === -1 && this.user?.showPlatforms[i].platform) {
            this.platforms.push(this.user?.showPlatforms[i].platform);
          }
        }
      }
      this.organizationService.getCountry().subscribe((result: any) => {
        this.countries = result;
        this.userService.getRoles().subscribe((roleResult: any) => {
          this.roles = [];
          for (let i = 0; i < roleResult.length; i++) {
            let translation = this.translate.instant('main._' + roleResult[i].name);
            this.roles.push({value: roleResult[ i ].id ,
              label: translation});
          }
          this.userService.getLevelStatus().subscribe((levelResult: any) => {
            this.levelStatuses = [];
            for (let i = 0; i < levelResult.length; i++) {
              if (levelResult[ i ].status) {
                this.levelStatuses.push({value: levelResult[ i ].id , label: (levelResult[ i ].level + '/' + levelResult[ i ].status)});
              } else {
                this.levelStatuses.push({value: levelResult[ i ].id , label: (levelResult[ i ].level)});
              }
              if (this.user.status && this.user.status.indexOf(levelResult[i].id) !== -1) {
                if (this.readonlyData.statusLevel.data) {
                  this.readonlyData.statusLevel.data = this.readonlyData.statusLevel.data + ', ' + levelResult[i].level;
                } else {
                  this.readonlyData.statusLevel.data = this.readonlyData.statusLevel.data + levelResult[i].level;
                }
              }
            }
            this.spinner.show();
            this.userService.getTargetGroup(false).subscribe((targetResults: any) => {
              this.TGForRewards = targetResults.targetGroups;
              this.targetGroups = [];
              for (let i = 0; i < targetResults.targetGroups.length; i++) {
                this.targetGroups.push({
                  value: targetResults.targetGroups[ i ].id ,
                  label: ((('0' + targetResults.targetGroups[ i ].targetNumber).slice(-2)) + ' - ' + targetResults.targetGroups[ i ].ageMask)
                });
                if (this.user.targetGroupId && this.user.targetGroupId === targetResults.targetGroups[i].id) {
                  this.readonlyData.targetGroup.data = targetResults.targetGroups[i].ageMask;
                }
              }
              this.userService.getConfession().subscribe((confessioResults: any) => {
                this.confessions = confessioResults;
                for (let i = 0; i < confessioResults.length; i++) {
                  if (this.user.confessionId && this.user.confessionId === confessioResults[i].name) {
                    this.readonlyData.confession.data = confessioResults[i].name;
                  }
                }
                this.noOrganization = this.user.organization.isGuest;
                this.initForm(this.user);
                this.updateReadOnlyData(this.user);
                this.getCompetencies();
                setTimeout(() => {
                  this.spinner.hide();
                }, 500);
              });
            });
          });
        });
      });
    });
  }

  getCompetencies() {
    this.userService.getUserCompetencies(this.id).subscribe({
      next: (res: any) => {
        this.competencies = res;
      },
      error: (err) => {
      }
    });
  }

  getFollowingOrganization(){
    this.organizationService.getFollowingOrganization(this.user.id).subscribe({
      next: (res: any) => {
        if (res?.length) {
          this.followingOranization = res;
          for (let i = 0; i < this.followingOranization.length; i++) {
            let index =  this.organizationForFollowing.findIndex(el => +el.id === +this.followingOranization[i].organizationId);
            if (index !== -1) {
              this.organizationForFollowing.splice(index, 1);
            }
          }
        }
      },
      error: (err) => {
      }
    });
  }

  getOrgForFollowing(){
    this.organizationForFollowing = [];
    this.followingOranization = [];
    this.organizationService.getOrganizationForFollowing().subscribe({
      next: (res: any) => {
        if (res?.length) {
          this.organizationForFollowing = res;
          let index =  this.organizationForFollowing.findIndex(el => +el.id === +this.user.organizationId);
          if (index !== -1) {
            this.organizationForFollowing.splice(index, 1);
          }
          this.getFollowingOrganization();
        }
      },
      error: (err) => {
        this.getFollowingOrganization();
      }
    });
  }

  addFollowOrganization() {
    this.addingOrganization = true;
  }

  saveFollowingOrg() {
    let obj = {
      frontUserId: this.user.id,
      organizationId: this.selectedOrgObj.id
    };
    this.organizationService.addFollowOrganization(obj).subscribe((res) => {
      this.addingOrganization = false;
      this.selectedOrgObj = null;
      this.selectedOrg.patchValue(null);
      this.getOrgForFollowing();
    });
  }

  removeFollowingOrg(id) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent, {
      width: '300px',
      panelClass: 'unsave-form-dialog',
      height: 'auto',
      data: {title: 'Delete', message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.organizationService.deleteFollowOrganization(id).subscribe((res) => {
          this.getOrgForFollowing();
        });
      }
    });
  }

  verify(type, msg = '') {
    if (type === 'verify') {
      this.userService.validationUser({type: type, id: this.id, msg: msg}).subscribe((res) => {
        if (res) {
          this.validateButton = true;
          this.getInfoAboutUser();
        }
      });
    }
    if (type === 'rejection') {
      const dialogRef = this.dialog.open(DialogVerifyDialog, {
        width: '450px',
        data: {type: type, text: ''}
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.userService.validationUser({type: type, id: this.id, msg: result}).subscribe((res) => {
            if (res) {
              this.router.navigate(['./pages/frontusersnoactive']);
            }
          });
        }
      });
    }
    if (type === 'correction') {
      const dialogRef = this.dialog.open(DialogVerifyDialog, {
        width: '450px',
        data: {type: type, text: ''}
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.userService.validationUser({type: type, id: this.id, msg: result}).subscribe((res) => {
            if (res) {
              this.router.navigate(['./pages/frontusersnoactive']);
            }
          });
        }
      });
    }

  }

  selectTg(event) {
    const id = this.route.snapshot.queryParamMap.get('id');
    if (event.value !== 'all') {
      this.userService.getUserTG(id, event.value).subscribe((res) => {
        if (res) {
          this.dataTGSelected = res;
          this.updateDateSelected = moment().valueOf();
        } else {
          this.dataTGSelected = '';
        }
      });
      this.spinner.show();
      this.userService.getEvents(id, event.value).subscribe((res) => {
        if (res) {
          this.eventsScore = res;
          if (this.eventsScore && this.eventsScore.newEvents) {
            this.newEventsScore = this.eventsScore.newEvents.reduce((sum, current) => {
              let value = 0;
              if (current && current.event && current.event.credits) {
                value = current.event.credits;
              }
              return sum + value;
            }, 0);
          }
          if (this.eventsScore && this.eventsScore.oldEvents) {
            this.oldEventsScore = this.eventsScore.oldEvents.reduce((sum, current) => {
              let value = 0;
              if (current && current.credits) {
                value = current.credits;
              } else {
                if (current && current.event && current.event.credits) {
                  value = current.event.credits;
                }
              }
              return sum + value;
            }, 0);
          }
          if (this.eventsScore && this.eventsScore.manual) {
            this.oldEventsScore = this.oldEventsScore + this.eventsScore.manual.reduce((sum, current) => {
              let value = 0;
              if (current && current.credits) {
                value = current.credits;
              }
              return sum + value;
            }, 0);
          }
        }
        this.spinner.hide();
      });
      this.userService.getListOfRewards(id, event.value).subscribe((res) => {
        if (res) {
          this.rewards = res;
        }
      });
    } else {
      this.getAllUserTg(id);
      this.spinner.show();
      this.userService.getAllEvents(id).subscribe((res) => {
        if (res) {
          this.eventsScore = res;
          if (this.eventsScore && this.eventsScore.newEvents) {
            this.newEventsScore = this.eventsScore.newEvents.reduce((sum, current) => {
              let value = 0;
              if (current && current.event && current.event.credits) {
                value = current.event.credits;
              }
              return sum + value;
            }, 0);
          }
          if (this.eventsScore && this.eventsScore.oldEvents) {
            this.oldEventsScore = this.eventsScore.oldEvents.reduce((sum, current) => {
              let value = 0;
              if (current && current.credits) {
                value = current.credits;
              } else {
                if (current && current.event && current.event.credits) {
                  value = current.event.credits;
                }
              }
              return sum + value;
            }, 0);
          }
          if (this.eventsScore && this.eventsScore.manual) {
            this.oldEventsScore = this.oldEventsScore + this.eventsScore.manual.reduce((sum, current) => {
              let value = 0;
              if (current && current.credits) {
                value = current.credits;
              }
              return sum + value;
            }, 0);
          }
        }
        this.spinner.hide();
      });
    }
  }

  getAllUserTg(id) {
    this.userService.getAllUserTG(id, this.allTgIds).subscribe((res: any) => {
      if (res) {
        let _allTg = {
          id: 'all',
          subCredit: [],
          creditTarget: 0
        };
        res.forEach(el => {
          if (el.subCredit.length) {
            el.subCredit.forEach((sc) => {
              let element = _allTg.subCredit.findIndex(_sc => _sc.eventTypeId === sc.eventTypeId);
              if (element === -1) {
                sc.eventType = {
                  name: sc.name,
                  oldName: sc.oldName,
                  color: sc.color
                };
                _allTg.subCredit.push(sc);
              } else {
                _allTg.subCredit[element].credit = +_allTg.subCredit[element].credit + +sc.credit;
              }
            });
          }
          _allTg.creditTarget = +_allTg.creditTarget + +el.creditTarget;
        });
        if (+this.index === 1) {
          this.dataTGSelected = _allTg;
          this.updateDateSelected = moment().valueOf();
        } else {
          this.credits = _allTg;
          this.updateDate = moment().valueOf();
        }
      }
    });
  }

  changeTab(event) {
    this.index = event.index;
    const id = this.route.snapshot.queryParamMap.get('id');
    if (+this.index === 1) {
      let curTg = this.allTG.find(el => el.current);
      if (curTg) {
        this.selectTg({value: curTg.id});
      }
    }
    if (+this.index === 0 && this.allTgIds) {
      this.getAllUserTg(id);
    }
  }

  refreshData(event) {
    const id = this.route.snapshot.queryParamMap.get('id');
    this.userService.getUserTG(id, '').subscribe((res) => {
      if (res) {
        this.dataTGSelected = res;
        this.dataTGCurrent = res;
        this.updateDate = moment().valueOf();
        this.updateDateSelected = moment().valueOf();
      }
    });
    this.userService.getEvents(id, '').subscribe((res) => {
      if (res) {
        // this.eventsScore = res;
        this.events = res;
      }
    });
    this.userService.getListOfRewards(id, '').subscribe((res) => {
      if (res) {
        this.rewards = res;
      }
    });
  }

  ngOnInit() {
    this.spinner.show();
    this.initForm({});
    this.filteredOptions = this.selectedOrg.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this._filter(name as string) : this.organizationForFollowing.slice();
      }),
    );

    this.selectedOrgSubscription = this.selectedOrg.valueChanges.pipe(
      distinctUntilChanged((prev, curr) => {
        if (typeof prev === 'object' && typeof curr === 'object' && prev && curr) {
          return prev.id === curr.id;
        }
        return prev === curr;
      })
    ).subscribe(value => {
      this.selectedOrgObj = value;
    });
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.organizationForFollowing.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  displayFn(organization: any) {
    return organization ? organization.name : '';
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    if (this.selectedOrgSubscription) {
      this.selectedOrgSubscription.unsubscribe();
    }
  }


  sendEmail() {
    this.userService.sendEmailPass(this.id).subscribe((res) => {
      this.toastr.success('Mail sent', 'Success!');
    });
  }

  initForm(data) {
    this.formGroup.get('email').valueChanges.subscribe(res => {
      const errors = this.formGroup.controls.email.errors;
      if (!errors && res) {
        this.userService.checkEmailValid(res, data.email).subscribe((result: any) => {
          if (result.user) {
            this.formGroup.controls.email.setErrors({checkEmailOnServer: true});
          }
        });
      }
    });
    this.formGroup.get('countryId').valueChanges.subscribe((res) => {
      this.organizationService.getCity(res).subscribe((result: any) => {
        this.cities = result;
      });
    });

    this.formGroup.get('cityId').valueChanges.subscribe((res) => {
      if (res) {
        this.organizationService.getOrganizationByCity(res).subscribe((result: any) => {
          this.organizations = result;
        });
      }
    });
    this.formGroup.get('organizationId').valueChanges.subscribe((res) => {
      if (res) {
        this.organizationService.getTagByOrganization(res).subscribe((result: any) => {
          this.tags = [];
          this.tags.push({value: null, label: '-'});
          for (let i = 0; i < result.length; i++) {
            this.tags.push({value: result[i].id, label: result[i].name});
          }
        });
      }
    });
    this.formGroup.get('frontRoleId').valueChanges.subscribe((res) => {
      const selectControlCountry = this.formGroup.get('countryId');
      const selectControlConfession = this.formGroup.get('confessionId');
      const selectControlTargetGroup = this.formGroup.get('targetGroupId');
      const selectControlCanton = this.formGroup.get('cityId');
      const selectControlOrganization = this.formGroup.get('organizationId');
      const selectControlTag = this.formGroup.get('tagId');
      const selectControlGender = this.formGroup.get('gender');
      const inputControlFirstName = this.formGroup.get('firstName');
      const inputControlLastName = this.formGroup.get('lastName');
      const inputControlNickName = this.formGroup.get('nickName');
      const inputControlStreet = this.formGroup.get('street');
      const inputControlNumber = this.formGroup.get('number');
      const inputControlPostcode = this.formGroup.get('postcode');
      const inputControlCity = this.formGroup.get('cityLocation');
      const inputControlPhone: any = this.formGroup.get('phone');
      const inputControlMobile: any = this.formGroup.get('mobile');
      const inputControlEmail = this.formGroup.get('email');
      const inputControlDateOfBirth = this.formGroup.get('dateOfBirth');
      const inputControlDateOfBaptism = this.formGroup.get('dateOfBaptism');
      const inputControlIntrodactionDate = this.formGroup.get('introdactionDate');
      const inputControlDateOfConfirmation = this.formGroup.get('dateOfConfirmation');
      const inputControlNotes = this.formGroup.get('notes');
      const inputControlAbschlussjahr = this.formGroup.get('abschlussjahr');
      const inputControlStatus = this.formGroup.get('status');
      const checkboxControlShowFoto = this.formGroup.get('showFoto');
      const checkboxControlShowChildrenName = this.formGroup.get('showChildrenName');
      const checkboxControlShowNick = this.formGroup.get('showNick');
      const chexboxControlIsMember = this.formGroup.get('isMember');
      const radioControlLoginType = this.formGroup.get('loginType');
      const selectControlPlatform = this.formGroup.get('platformId');

      if (res === 1) {
        selectControlCountry.enable({emitEvent: false});
        selectControlCanton.enable({emitEvent: false});
        selectControlOrganization.enable({emitEvent: false});
        selectControlTag.enable();
        inputControlFirstName.enable();
        inputControlLastName.enable();
        inputControlNickName.enable();
        inputControlEmail.enable({emitEvent: false});
        selectControlGender.enable();
        inputControlStreet.enable();
        inputControlNumber.enable();
        inputControlPostcode.enable();
        inputControlCity.enable();
        inputControlPhone.enable();
        inputControlMobile.enable();
        inputControlDateOfBirth.enable();

        inputControlDateOfBaptism.enable();
        inputControlIntrodactionDate.enable();
        inputControlDateOfConfirmation.enable();
        inputControlNotes.enable();
        inputControlAbschlussjahr.enable();
        inputControlStatus.enable();
        selectControlTargetGroup.enable();
        selectControlConfession.enable();
        checkboxControlShowFoto.enable();
        checkboxControlShowChildrenName.enable();
        checkboxControlShowNick.enable();
        this.parentPage = false;
        this.studentPage = true;
        chexboxControlIsMember.enable();
        radioControlLoginType.enable();
        selectControlPlatform.enable();
      } else if (res === 2) {
        selectControlCountry.enable({emitEvent: false});
        selectControlCanton.enable({emitEvent: false});
        selectControlOrganization.enable({emitEvent: false});
        inputControlFirstName.enable();
        inputControlLastName.enable();
        inputControlNickName.disable();
        inputControlEmail.enable({emitEvent: false});
        selectControlTag.enable();

        selectControlGender.enable();
        inputControlStreet.enable();
        inputControlNumber.enable();
        inputControlPostcode.enable();
        inputControlCity.enable();
        inputControlPhone.enable();
        inputControlMobile.enable();
        inputControlDateOfBirth.enable();

        inputControlDateOfBaptism.disable();
        inputControlIntrodactionDate.disable();
        inputControlDateOfConfirmation.disable();
        inputControlAbschlussjahr.disable();
        inputControlStatus.enable();
        selectControlTargetGroup.disable();
        selectControlConfession.enable();
        checkboxControlShowFoto.disable();
        checkboxControlShowChildrenName.disable();
        checkboxControlShowNick.disable();
        this.parentPage = true;
        this.studentPage = false;
        chexboxControlIsMember.enable();
        radioControlLoginType.enable();
        selectControlPlatform.enable();
      }
    });
    if (data.status) {
      if (!Array.isArray(data.status)) {
        data.status = data.status.split(',');
      }
      for (let i = 0; i < data.status.length; i++) {
        data.status[i] = parseInt(data.status[i], 10);
      }
    }
    if (data.tagId) {
      if (!Array.isArray(data.tagId)) {
        data.tagId = (data.tagId).toString().split(',');
      }
      for (let i = 0; i < data.tagId.length; i++) {
        data.tagId[i] = parseInt(data.tagId[i], 10);
      }
    }
    if (data.dateOfBirth) {
      data.dateOfBirth = new Date(data.dateOfBirth);
    }
    if (data.dateOfBaptism) {
      data.dateOfBaptism = new Date(data.dateOfBaptism);
    }
    if (data.introdactionDate) {
      data.introdactionDate = new Date(data.introdactionDate);
    }
    if (data.dateOfConfirmation) {
      data.dateOfConfirmation = new Date(data.dateOfConfirmation);
    }
    if (!data.loginType && data.email && data.showLoginType) {
      data.loginType = 'email';
    }
    this.formGroup.patchValue(data);
    if (this.countries.length === 1) {
      this.formGroup.patchValue({countryId: this.countries[0].id});
    }
    if (this.cities.length === 1) {
      this.formGroup.patchValue({cityId: this.cities[0].id});
    }
    if (this.organizations.length === 1) {
      this.formGroup.patchValue({organizationId: this.organizations[0].id});
    }
  }

  startEdit() {
    this.editing = true;
  }

  addParishOrg() {
    this.parishOrgs.push({parishOrganizationId: null, activityId: null});
  }

  removeParishOrg(index: number) {
    this.parishOrgs.splice(index, 1);
  }

  get canSaveParishOrgs(): boolean {
    return +this.user?.organizationId === 289 && !!this.user?.id && !this.savingParishOrgs && !this.loadingParishOrgs &&
      this.parishOrgs.every(item =>
        item.parishOrganizationId != null && item.activityId != null);
  }

  saveParishOrgs() {
    if (!this.canSaveParishOrgs) {
      return;
    }
    const data = this.parishOrgs.map(item => ({
      parishOrganizationId: item.parishOrganizationId,
      activityId: item.activityId
    }));
    this.savingParishOrgs = true;
    this.subscriptions.add(this.parishOrganizationService.saveFrontUserParishOrgs(+this.user.id, data).pipe(
      finalize(() => this.savingParishOrgs = false)
    ).subscribe({
      next: () => {
        this.toastr.success(this.translate.instant('successfully'));
      },
      error: () => {
        this.toastr.error(this.translate.instant('failure'));
      }
    }));
  }

  setFileAccess(event) {
    this.fileAccess = event;
  }

  cancelEdit() {
    this.editing = false;
  }

  updateUser() {
    const data = this.formGroup.getRawValue();
    data.file = this.uploadedImg;
    data.id = this.user.id;
    if (+this.user.organizationId === 289) {
      data.additionalFrontUserInfo = JSON.stringify(this.additionalFrontUserInfo);
    }
    if (data.phone) {
      data.phone = normalizePhoneNumber(data.phone);
    }
    if (data.mobile) {
      data.mobile = normalizePhoneNumber(data.mobile);
    }
    if (data.dateOfBirth) {
      data.dateOfBirth = moment(data.dateOfBirth).format('DD.MM.YYYY');
    }
    if (data.dateOfBaptism) {
      data.dateOfBaptism = moment(data.dateOfBaptism).format('DD.MM.YYYY');
    }
    if (this.guestOrganization && this.noOrganization && +this.platformId === 6) {
      data.cityId = +this.guestOrganization.cityId;
      data.organizationId = this.guestOrganization.id;
    }
    if (!isValidPhoneNumber(data.phone)) {
      this.toastr.error('Enter correct phone number', 'Error!');
    } else if (!isValidPhoneNumber(data.mobile)) {
      this.toastr.error('Enter correct mobile number', 'Error!');
    } else if (!this.checkUserLogin(data)) {
      return;
    } else {
      this.userService.addUser(data).subscribe((res) => {
        this.toastr.success('User updated', 'Success!');
        this.loaderService.setLoader(true);
        if (res) {
          this.router.navigate(['./pages/frontusers']);
          this.loaderService.setLoader(false);
        }
      });
    }
  }

  checkUserLogin(data) {
    if (data.showLoginType && data.loginType === 'email' && !data.email) {
      let title = this.translate.instant('failure');
      let msg = this.translate.instant('frontUser.emptyEmailError');
      this.toastr.error(msg, title);
      return false;
    }
    if (data.showLoginType && data.loginType === 'mobile' && !data.mobile) {
      let title = this.translate.instant('failure');
      let msg = this.translate.instant('frontUser.emptyMobileError');
      this.toastr.error(msg, title);
      return false;
    }
    return true;
  }

  deleteUser() {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent, {
      width: '300px',
      panelClass: 'unsave-form-dialog',
      height: 'auto',
      data: {title: 'Delete', message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.userService.deleteUser(this.user.id).subscribe((res) => {
          this.toastr.success('User deleted', 'Success!');
          this.router.navigate(['./pages/frontusers']);
        });
      }
    });
  }

  addPartnerCheck(type, data) {
    let dialogRef = this.dialog.open(CheckRoleModalComponent, {
      panelClass: 'check-role-modal',
      width: '400px',
    });
    dialogRef.afterClosed().toPromise().then((result => {
      if (result) {
        this.addParent(type, data, result);
      }
    }));
  }

  addParent(type, data, role) {
    this.dialogRef = this.dialog.open(FrontUserFormDialogComponent, {
      panelClass: 'contact-form-dialog',
      width: '70vw',
      data: {
        action: type,
        type: this.parentPage ? 'parent' : 'student',
        data: data,
        userData: this.user,
        userRole: role,
        ageType: +role === 2 ? 'adult' : 'young'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe((response: any) => {
        if (response && response[1] === 'save') {
          if (type === 'new') {
            this.userService.addUser(response[0].getRawValue()).subscribe((res: any) => {
              if (res) {
                let isAdult = response[0].gender.isAdult;
                if (!isAdult && !response[0].gender.isChild) {
                  if (this.parentPage) {
                    isAdult = true;
                  }
                }
                let _userCon = {
                  frontUserId: this.user.id,
                  connectedUserId: res.id,
                  genderTypeId: response[0].getRawValue().genderType,
                  isAdult: isAdult,
                  representative: response[0].getRawValue().representative
                };
                this.genderService.addUserConnection(_userCon).subscribe((uc_res: any) => {
                  if (uc_res) {
                    this.createConnection(res.firstName + ' ' + res.lastName, response[0].getRawValue().genderType, res.id);
                  }
                  this.getConnection(this.id);
                });
              }
            });
          }
        }
        if (response && response[1] === 'connect') {
          let isAdult = response[0].gender.isAdult;
          if (!response[0].gender.isAdult && !response[0].gender.isChild
          && this.user.frontRoleId === 2 && response[0].frontRoleId === 2) {
            isAdult = true;
          }
          let _userCon = {
            frontUserId: this.user.id,
            connectedUserId: response[0].id,
            genderTypeId: response[0].genderType,
            isAdult: isAdult,
            representative: response[0].value.representative
          };
          this.genderService.addUserConnection(_userCon).subscribe((uc_res: any) => {
            if (uc_res && !uc_res.error) {
              this.getConnection(this.id);
            } else if (uc_res && uc_res.error && uc_res.error === 'userExist') {
              const text = this.translate.instant('user_already_linked');
              this.snackBar.open(text, '', {duration: 10000});
            }
          });
        }
      });
  }

  createConnection(userName, type, userId) {
    this.dialogRef = this.dialog.open(AddConnection, {
      panelClass: 'contact-form-dialog',
      width: '500px',
      data: {
        userName: userName,
        type,
        countType: 'one',
        currentUserName: this.user.firstName + ' ' + this.user.lastName,
        userType: this.parentPage ? 'parent' : 'student'

      }
    });

    this.dialogRef.afterClosed().subscribe(res => {
      if (res) {
        let isAdult = res.isAdult;
        if (!isAdult && !res.isChild) {
          if (this.parentPage) {
            isAdult = true;
          }
        }
        let _userCon = {
          frontUserId: userId,
          connectedUserId: this.user.id,
          genderTypeId: res.id,
          isAdult: isAdult
        };
        this.genderService.addUserConnection(_userCon).subscribe(uc_res => {
          this.getConnection(this.id);
        });
      }
    });
  }

  getConnection(userId) {
    this.genderService.userConnections(userId).subscribe((res: any) => {
      this.connectedRelatives = res;
      this.adultExist = !!this.connectedRelatives.filter(el => el.isAdult).length;
      this.youngExist = !!this.connectedRelatives.filter(el => !el.isAdult).length;
    });
  }

  getClan() {
    this.userService.getClan(this.id).subscribe((res) => {
      this.clan = res;
      this.connectedYoung = [];
      this.connectedAdult = [];
      this.clan.forEach(el => {
        if (el.users && el.title === 'young') {
          el.users.forEach(us => {
            if (!us.onlyForClan) {
              let _user = {
                genderType: us.genderType ? us.genderType : {name: us.role},
                connectedUser: us.user,
                isConnected: us.isConnected,
                connection: us.connection
              };
              this.connectedYoung.push(_user);
            }
          });
        }
        if (el.users && el.title === 'adult') {
          el.users.forEach(us => {
            if (!us.onlyForClan) {
              let _user = {
                genderType: us.genderType ? us.genderType :  {name: us.role},
                connectedUser: us.user,
                isConnected: us.isConnected,
                connection: us.connection
              };
              this.connectedAdult.push(_user);
            }
          });
        }
      });
    });
  }

  communicationAction(event) {
    let ids = [];
    ids.push(this.id);
    this.router.navigate(['/pages/communications'], {
      queryParams: {
        type: event.value,
        ids: ids.toString(),
      }
    });
  }

  setImg(img) {
    this.uploadedImg = img;
  }

  filesForUpload(event) {
    this.documentData = {files: event, type: 'frontUser', connectedId: this.user.id};
    const data = this.formGroup.value;
    data.file = this.uploadedImg;
    data.id = this.user.id;
    this.userService.addUser(data).subscribe((res) => {
      this.loaderService.setLoader(true);
      if (res) {
        if (this.documentData && this.documentData.files.length) {
          this.documentService.uploadDocument(this.documentData).subscribe((resDoc) => {
            if (resDoc) {
              this.loaderService.setLoader(false);
            }
          });
        } else {
          this.loaderService.setLoader(false);
        }
      }
    });

  }

  updateReadOnlyData(user) {
    this.readonlyData.abschlussjahr.data = user.abschlussjahr;
    this.readonlyData.city.data = user.city.name;
    this.readonlyData.country.data = user.country.name;
    this.readonlyData.dateOfBaptism.data = user.dateOfBaptism;
    this.readonlyData.introdactionDate.data = user.introdactionDate;
    this.readonlyData.dateOfConfirmation.data = user.dateOfConfirmation;
    this.readonlyData.dateOfBirth.data = user.dateOfBirth;
    this.readonlyData.detailOfTargetGroup.data = user.detailOfTargetGroup;
    this.readonlyData.email.data = user.email;
    this.readonlyData.firstName.data = user.firstName;
    this.readonlyData.frontRole.data = user.frontRole.name === 'student' ? this.language === 'en' ? 'individual account'
      : 'Einzelaccount' : this.language === 'en' ? 'parent' : 'Elternteil';
    this.readonlyData.gender.data = user.gender;
    this.readonlyData.lang.data = user.lang === 'en' ? 'English' : 'Germany';
    this.readonlyData.lastName.data = user.lastName;
    this.readonlyData.mobile.data = user.mobile;
    this.readonlyData.nickName.data = user.nickName;
    this.readonlyData.notes.data = user.notes;
    this.readonlyData.number.data = user.number;
    this.readonlyData.organization.data = user.organization.name;
    this.readonlyData.tag.data = user.tag ? user.tag.name : '-';
    this.readonlyData.phone.data = user.phone;
    this.readonlyData.postcode.data = user.postcode;
    this.readonlyData.street.data = user.street;
    this.readonlyData.showFoto.data = user.showFoto;
    this.readonlyData.showChildrenName.data = user.showChildrenName;
    let that = this;
    this.readArray = [];
    _.mapValues(this.readonlyData, function (o) {
      that.readArray.push(o);
      return o;
    });
  }

  openModal() {
    let dialogRef;
    dialogRef = this.dialog.open(RewardsModalComponent, {
      panelClass: 'add-rewards-dialog',
      width: '70vw'
    });
    dialogRef.afterClosed()
      .subscribe((response: any) => {
        if (response) {
          const id = this.route.snapshot.queryParamMap.get('id');
          let data = {eventTypeId: '', credits: '', type: '', fronUserId: '', comment: ''};
          data.eventTypeId = response.eventType;
          data.credits = response.credits;
          data.comment = response.comment;
          data.type = 'custom';
          data.fronUserId = id;
          this.userService.addRewards(data).subscribe((res) => {
            if (res) {
              this.refreshData(Date.now());
              this.userService.updateAllYearsRewards(id).subscribe(result => {

              });
            }
          });
        }
      });
  }

  refreshBadge() {
    this.subscriptions.add(this.userService.getNumberOfNew().subscribe((res) => {
      const mailNavItem = this.navigationService.getNavigationItem('frontusers.frontNoVerify');
      mailNavItem.badge.title = res;
    }));
  }

  removeReward(event, id) {
    let dialogRef;
    dialogRef = this.dialog.open(FuseDeleteDialogComponent, {
      panelClass: 'unsave-form-dialog',
      width: '400px',
      data: {title: 'Delete' , message: 'deleteConfirm'}
    });
    dialogRef.afterClosed()
      .subscribe((response: any) => {
        if (response) {
          this.userService.deleteReward(id).subscribe((res) => {
            if (res) {
              this.refreshData(Date.now());
            }
          });
        }
      });
  }

  removeEventReward(event) {
    let dialogRef;
    dialogRef = this.dialog.open(FuseDeleteDialogComponent, {
      panelClass: 'unsave-form-dialog',
      width: '400px',
      data: {title: 'Delete' , message: 'deleteConfirm'}
    });
    dialogRef.afterClosed()
      .subscribe((response: any) => {
        if (response) {
          this.userService.deleteEventReward(event.eventId, event.frontUserId).subscribe((res) => {
            if (res) {
              this.refreshData(Date.now());
            }
          });
        }
      });
  }

  updateRewards(event) {
    this.getEvents();
  }

  updateAllRewards(event) {
    this.selectTg({value: this.selected});
  }

  deleteRequest() {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent, {
      panelClass: 'unsave-form-dialog',
      width: '300px',
      height: 'auto',
      data: {title: 'delete_delete_request', message: 'delete_delete_request_confirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.userService.removeDeleteRequest(this.user.id).subscribe(res => {
          this.toastr.success('User request deleted', 'Success!');
          this.router.navigate(['./pages/frontusers']);
        });
      }
    });
  }

  deleteProfile() {
    let userId: any = +this.user.id * 12345654321;
    userId = userId.toString(16);
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent, {
      panelClass: 'unsave-form-dialog',
      width: '300px',
      height: 'auto',
      data: {title: 'complete_delete_request', message: 'complete_delete_request_confirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.userService.deleteUserProfile(userId).subscribe(res => {
          this.toastr.success('User request deleted', 'Success!');
          this.router.navigate(['./pages/frontusers']);
        });
      }
    });
  }

  deleteFrontUserTask(id: number) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent, {
      panelClass: 'unsave-form-dialog',
      width: '300px',
      data: {title: 'Delete', message: 'deleteConfirm'}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.spinner.show();
        this.frontUserTaskService.deleteFrontUserTask(id)
          .pipe(finalize(() => this.spinner.hide())).subscribe({
            next: () => this.getInfoAboutUser(),
            error: () => this.toastr.error(this.translate.instant('tasks.delete_error'))
          });
      }
    });
  }

  addTask() {
    const tasks: UserTaskAssignment[] = (this.user?.frontUserTasks || []).filter((task: UserTaskAssignment) =>
      !task.eventId && !task.elearningId && !task.learningPathsId && !task.learnPathsId);
    const dialogRef = this.dialog.open<AddTaskModalComponent, AddTaskModalData, Task[]>(AddTaskModalComponent, {
      panelClass: 'contact-form-dialog',
      width: '700px',
      data: {tasks}
    });
    dialogRef.afterClosed().subscribe(selectedTasks => {
      if (!selectedTasks?.length) {
        return;
      }
      this.spinner.show();
      this.frontUserTaskService.addFrontUserTask({
        frontUserId: this.user.id,
        taskIds: selectedTasks.map(task => task.id)
      }).pipe(finalize(() => this.spinner.hide())).subscribe({
        next: () => this.getInfoAboutUser(),
        error: () => this.toastr.error(this.translate.instant('tasks.save_error'))
      });
    });
  }

  verifyTask(id: number, task: any) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent, {
      width: '300px',
      panelClass: 'unsave-form-dialog',
      height: 'auto',
      data: {title: 'tasks.verify_title', message: 'tasks.verify_confirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (task.certificateAllowed && task.certificateTemplateId){
          this.sendCertificate(id);
        } else {
          this.verifyTaskFunc(id, false);
        }
      }
    });
  }

  sendCertificate(id) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent, {
      width: '300px',
      panelClass: 'unsave-form-dialog',
      height: 'auto',
      data: {title: 'tasks.send_certificate', message: 'tasks.send_certificate_msg'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
          this.verifyTaskFunc(id, true);
      } else {
        this.verifyTaskFunc(id, false);
      }
    });
  }

  reSendCertificate(taskId) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent, {
      width: '300px',
      panelClass: 'unsave-form-dialog',
      height: 'auto',
      data: {title: 'tasks.send_certificate', message: 'tasks.send_certificate_msg'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.spinner.show();
        this.certificateTemplateService.sendTaskCertificate(this.user.id, taskId).subscribe({
          complete: () => {
            let msg = this.translate.instant('tasks.send_certificate_success');
            this.toastr.success(msg);
            this.getInfoAboutUser();
            this.spinner.hide();
          }
        });
      }
    });
  }

  verifyTaskFunc(id, sendCertificate) {
    this.spinner.show();
    this.frontUserTaskService.verify(id, sendCertificate).subscribe(() => {
      this.getInfoAboutUser();
      this.spinner.hide();
    });
  }

  rejectTask(id: number) {
    const dialogRef = this.dialog.open<RejectTaskDialogComponent,
      void, RejectTaskDialogResult>(RejectTaskDialogComponent, {
      width: '400px',
      panelClass: 'unsave-form-dialog',
      height: 'auto'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.frontUserTaskService.reject(id, result.adminComment).subscribe(() => {
          this.getInfoAboutUser();
        });
      }
    });
  }
}


@Component({
    selector: 'dialog-verify-dialog',
    templateUrl: 'dialog-verify-dialog.html',
    standalone: false
})
export class DialogVerifyDialog {
  comment = '';

  constructor(
    public dialogRef: MatDialogRef<DialogVerifyDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  send(comment) {
    this.dialogRef.close(comment);
  }
}
